import Image from 'next/image';
import { Badge, Box, Heading } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { DATA_HOOKS } from '../../../../dataHooks';
import css from './index.module.scss';

export type GenAnswerHeaderProps = {
  searchQuestion: string;
};

export const GenAnswerHeader: FunctionComponent<GenAnswerHeaderProps> = (
  { searchQuestion }
) => {
  const { t } = useTranslation();

  return (
    <Box direction="horizontal" className={css.genAnswerHeader}>
      <Box direction="horizontal" verticalAlign='top'>
        <Box className={css.aiIconWrapper}>
        </Box>
        <Heading className={css.title} ellipsis maxLines={2} dataHook={DATA_HOOKS.GEN_ANSWER_HEADING}>
          <span className={css.aiAnswer}>
            <Image
              src="https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/icons/ai.svg"
              height={24}
              width={24}
              alt="ai"
            />
            {t('search-results-page.gen-answer.AI-answer')}
          </span>
          <span data-hook={DATA_HOOKS.GEN_ANSWER_QUESTION} className={css.searchQuestion}>{t('search-results-page.gen-answer.for-question', { searchQuestion })}</span>
        </Heading>
      </Box>
      <Box className={css.betaDisclaimerWrapper} dataHook={DATA_HOOKS.BETA_GEN_ANSWER}>
        <Badge className={css.betaDisclaimer} uppercase={false} skin="neutralLight" type="outlined">
          {t('search-results-page.gen-answer.beta')}
        </Badge>
      </Box>
    </Box>
  );
};
